import React, { useEffect, useState } from "react";
import { DropBox } from "../../../components";
import { getLanguage } from "../../../utils/environment";
import { useDispatch } from "react-redux";
import { getAllJobsCategory } from "../../CreateNewItem/CreateNewJob/service/jobs.service";
import { setGazetteList, setJobgazetteList } from "../../Jobs/redux/actions";
import { getAllGazette } from "../../CreateNewItem/CreateNewGazette/service/jobs.service";
import moment from "moment";

const lan = getLanguage();

const Index = ({ data, onChangeGazette }) => {
  const [language, setLanguage] = useState("");
  const [formData, setFormData] = useState({
    gazetteDate: {
      key: "gazetteDate",
      label: "Gazette Date",
      size: "lg",
      placeholder: "-- Select Gazette Date --",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const dispatch = useDispatch();

  const fetchGazette = async () => {
    const updateForm = { ...formData };
    updateForm.gazetteDate.loading = true;
    updateForm["gazetteDate"].elementConfig.options = [];
    const response = await getAllGazette();
    if (response?.data) {
      let gazetteList = await syncGazette(response.data);
      updateForm["gazetteDate"].elementConfig.options = gazetteList;
      updateForm.gazetteDate.loading = false;
      dispatch(setGazetteList(response.data));

      setFormData(updateForm);
    }
  };

  const syncGazette = async (res) => {
    let gazetteList = [];

    for (let gazetteDate of res) {
      gazetteList.push({
        id: gazetteDate.gazette_id,
        key: gazetteDate.gazette_date,
        value: gazetteDate.gazette_date,
        displayValue: `gazette_${moment(gazetteDate.gazette_date)
          .format("MMM-DD")
          .toLowerCase()}`,
      });
    }
    return gazetteList;
  };

  useEffect(() => {
    if (formData.gazetteDate.elementConfig.options.length === 0) {
      fetchGazette();
    }
  }, []);

  useEffect(() => {
    if (data && data.language && data.language !== language) {
      setLanguage(data.language);
      fetchGazette();
    }
  }, [data]);

  const updateNewsForm = { ...formData };

  return (
    <>
      <DropBox
        data={updateNewsForm.gazetteDate}
        onChange={(e) => {
          const updateForm = { ...formData };
          updateForm["gazetteDate"].value = e;
          setFormData(updateForm);
          console.log("Gazette Date Select Box:", e);
          onChangeGazette(e);
        }}
      />
    </>
  );
};

export default Index;
